import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PagerList, GlobalInfo, FPMessage, Severities, PageKey, RoleAccess, SourceSystem, ImageModel } from '../../shared/shared.model';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { BaseComponent } from '../../shared/base.component';
import { SharedService } from '../../shared/shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Message, ConfirmationService, SelectItem, MultiSelectModule } from 'primeng/primeng';
import { LoaderService } from '../../shared/loader.service';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { TechnicianJobService } from '../../technician/technician-jobs/technician-jobs.service';
import { ClosePopup, RouteParams, WorkTypeDd, WorkRequestDd, WorkRequestSaveModel, Hours, Minutes, WorkRequestCFModel, WOCategory, WOPunchPoints, WoPunchPointsAttachment } from '../../technician/technician-jobs/technician-jobs.models';
import { AuthService } from 'app/authentication/auth.service';
import { API } from 'app/layout/core/app-config';

@Component({
    selector: 'add-punch-attachment',
    templateUrl: 'add-punch-attachment.html',
    styleUrls: ['attachment.css'],
    encapsulation: ViewEncapsulation.None
})

export class AddPunchAttachmentComponent extends BaseComponent implements OnInit {

    gi = new GlobalInfo;
    message = new FPMessage;
    popupClose = new ClosePopup;
    rp = new RouteParams;

    @Output() Close = new EventEmitter<ClosePopup>();
    @Input() HeaderName: string;
    @Input() WOPunchPointsId: number;
    @Input() roleAttachments: RoleAccess = new RoleAccess;
    
    //form intialize
    acceptTypes: string  = "image/*,audio/*.xlsx,.docx,.ppt,.txt,.pdf,.dwg";
    url: string;
    ifPreview: boolean = false;
    PunchAttachmentList: WoPunchPointsAttachment[] = [];
    PunchAttachmentListDetail: WoPunchPointsAttachment[] = [];
    previewImage: ImageModel[]
    currentAttachmentId: number;
    constructor(
        protected sharedService: SharedService,
        protected translate: TranslateService,
        private _technicianJobService: TechnicianJobService,
        private _fb: FormBuilder,
        private route: ActivatedRoute,
        private loaderService: LoaderService,
        private authService: AuthService,
        private confirmationService: ConfirmationService
    ) {

        super(sharedService, translate);
        this.gi = super.globalInfo();
    }

    ngOnInit() {
debugger;
this.roleAttachments;
        this.getRouteParams();
        this.url = API.WORKORDER + '/UploadPunchAttachment?CompanyId=' + super.globalInfo().CompanyId + '&WorkOrderId=' + this.rp.WorkOrderId + '&WOPunchPointsId=' + this.WOPunchPointsId + '&CreatedBy=' + super.globalInfo().LoginId;
        this.getAttachment();
    }

    getRouteParams(): void {
        this.route.params.subscribe(params => {
            this.rp.WoJobId = params['id'];
            this.rp.WorkOrderId = params['workOrderId'];
            this.rp.WoCategoryId = params['woCategoryId'];
            this.rp.TechnicianId = params['TechnicianId'];
            this.rp.WoNumber = params['WoNumber'];
        });
    }

    closePopup(msg: boolean) {
        this.popupClose.Responce = msg;
        this.Close.emit(this.popupClose);
    }
    onBeforeSend(event) {
        var ac_token = this.authService.getAuthorizationHeaderValue();
        event.xhr.setRequestHeader('Authorization', ac_token);
    }

    onUpload(event) {
        this.loaderService.show();
        setTimeout(() => { this.getAttachment(); }, 1000);
    }
    getAttachment() {
        this.loaderService.show();
        this.PunchAttachmentListDetail = [];
        this._technicianJobService.getPunchAttachment(this.gi.CompanyId, this.WOPunchPointsId, false)
            .subscribe(s => {
                this.loaderService.hide();
                this.PunchAttachmentList = s;
                for (let file of this.PunchAttachmentList) {
                    file.Type = file.AttachementType;
                    file.AttachementType = file.FileName.toLowerCase().split('.').pop();
                    file.DocType = false;
                    if (file.AttachementType == "png" || file.AttachementType == "jpg" || file.AttachementType == "jpeg" || file.AttachementType == "gif" || file.AttachementType == "dwg") {
                        file.DocType = true;
                    }
                    else if (file.AttachementType == "xls" || file.AttachementType == "xlsx") {
                        file.DocThumbImage = "../assets/img/logo/xls.png";
                    }
                    else if (file.AttachementType == "doc" || file.AttachementType == "docx") {
                        file.DocThumbImage = "../assets/img/logo/document.png";
                    }
                    else if (file.AttachementType == "ppt" || file.AttachementType == "pptx") {
                        file.DocThumbImage = "../assets/img/logo/ppt.png";
                    }
                    else if (file.AttachementType == "txt") {
                        file.DocThumbImage = "../assets/img/logo/document.png";
                    }

                    else if (file.AttachementType == "pdf") {
                        file.DocThumbImage = "../assets/img/logo/pdf.png";
                    }
                    else if (file.AttachementType == "mp4") {
                        file.DocThumbImage = "../assets/img/logo/movie.png";
                    }
                    else if (file.AttachementType == "mp3") {
                        file.DocThumbImage = "../assets/img/logo/mp3.png";
                    }
                    else if (file.AttachementType == "dwg") {
                        file.DocThumbImage = "../assets/img/logo/autocad.png";
                    }
                    else {
                        file.DocThumbImage = "../assets/img/logo/unknown.png";
                    }
                    // file.CapturedDateFormat = this.datetimeFormat(file.CapturedDate);
                    // file.LastUpdate = this.datetimeFormat(file.LastUpdate);
                    file.Type = file.Type == null ? 'Others' : file.Type;
                    file.AttachementTypeId = file.AttachementTypeId == 0 ? 74 : file.AttachementTypeId;//others
                    this.PunchAttachmentListDetail.push(file);
                }
            });
    }
    getAttachmentPreview() {
        this.loaderService.show();
        this.previewImage = [];
        this._technicianJobService.getPunchAttachment(this.gi.CompanyId, this.WOPunchPointsId, true)
            .subscribe(s => {
                this.loaderService.hide();
                this.ifPreview = true;
                s.forEach(d => {
                    if (d.AttachmentCategoryId == 67) {
                        var imageModel = new ImageModel()
                        imageModel.Attachment = d.ByteString;
                        imageModel.FileName = d.FileName;
                        imageModel.Description = d.Description;
                        imageModel.AttachmentId = d.WoPunchPointsAttachmentId;
                        imageModel.Tag = '';
                        imageModel.TagId = d.AttachementTypeId;
                        this.previewImage.push(imageModel);
                    }
                });
            });
    }
    deleteAttachments(data: WoPunchPointsAttachment) {
        debugger;
        this.confirmationService.confirm({
            message: this.translate.instant('5001'),
            header: 'Delete Confirmation',
            icon: 'fa fa-trash',
            accept: () => {
                this._technicianJobService.deletePunchAttachment(this.gi.CompanyId, data.WoPunchPointsAttachmentId)
                .subscribe(s => {
                    this.message = s.Message;
                    if (this.message.MessageCode == "1003") {
                        this.sharedService.notification.emit({
                            severity: Severities[this.message.Severity],
                            summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                            detail: this.translate.instant("ATTACHMENT") + this.translate.instant(this.message.MessageCode)
                        });
                    } else {
                        this.sharedService.notification.emit({
                            severity: Severities[this.message.Severity],
                            summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                            detail: this.translate.instant(this.message.MessageCode)
                        });
                    }
                    this.getAttachment();
                });
            },
            reject: () => {

            }
        });

     
    }
    responceMessage(res: any) {
        this.message = res.Message;
        if (this.message.MessageCode == "1011" || this.message.MessageCode == "1012") {
            this.sharedService.notification.emit({
                severity: Severities[this.message.Severity],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                detail: this.translate.instant(this.message.MessageCode)
            });
            this.closePopup(true);
        } else {
            this.sharedService.notification.emit({
                severity: Severities[this.message.Severity],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                detail: this.translate.instant(this.message.MessageCode)
            });
            this.closePopup(false);
        }
    }
    previewAttachments(data: WoPunchPointsAttachment) {
        this.currentAttachmentId = data.WoPunchPointsAttachmentId;
        this.getAttachmentPreview();
    }
    closePreview() {
        this.ifPreview = false;
    }
}

